export default __webpack_public_path__ + "static/heart-autos-0d91d602c866cf35950487f23ca1ca49.svg";